<div class="col-xl mb-5 mr-xl-5 pr-xl-5 scroll-test" [innerHtml]="data.copy | safe: 'html'"></div>
<div class="col-xl ml-xl-5 pl-xl-5">
  <app-video [data]="media"></app-video>
</div>
  
